import "./style.css";

const PloomDesignSystem = () => null;

export default PloomDesignSystem;
